<template>
  <v-container fluid class="panel">
    <v-layout row wrap align-baseline>
      <v-flex md8 xs12 align-content-center>
        <v-text-field append-icon="search" label="" :placeholder="$t('private_global.filter.by.customer.id')" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex md4 xs12 align-content-center class="topDatesSelector">
        <from-to-date-selector class="text-xs-right" @on-dates-selected="onDatesSelected"></from-to-date-selector>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="events"
          :rows-per-page-text="$t('global_tables_rows_page')"
          :total-items="totalEvents"
          :pagination.sync="pagination"
          :loading="isLoading"
          :rows-per-page-items="[5, 10, 25, 50]"
        >
          <v-progress-linear v-if="isLoading" slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.dateCreated }}</td>
            <td>{{ props.item.user }}</td>
            <td>{{ props.item.isOpen }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.description }}</td>
          </template>
          <template slot="no-data">
            <v-alert :value="true" outline color="info" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t('global_table_from_of_preposition') }}
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import doorService from '@/services/doorService';
import _ from 'lodash';
import keys from '@/store/keys';
import store from '@/store';
import moment from 'moment';
import FromDateSelector from '@/components/commons/FromToDateSelector.vue';

export default {
  name: 'door-events-table',
  props: ['parkingId'],
  components: { [FromDateSelector.name]: FromDateSelector },
  watch: {
    pagination: {
      handler() {
        this.queryChange();
      },
      deep: true
    },
    search: function(newValue) {
      this.debounceSearch();
    }
  },
  data() {
    return {
      debounceSearch: {},
      dates: [],
      totalEvents: 0,
      events: [],
      search: '',
      eventsRaw: [],
      isLoading: false,
      pagination: {
        rowsPerPage: 25,
        descending: true,
        sortBy: 'dateCreated'
      },
      headers: [
        {
          value: 'dateCreated',
          i18nText: 'private_parking_activity_events_access_date',
          text: this.$i18n.t('private_parking_activity_events_access_date'),
          sortable: true
        },
        {
          value: 'user',
          i18nText: 'private_parking_activity_events_access_user',
          text: this.$i18n.t('private_parking_activity_events_access_user'),
          sortable: false
        },
        {
          value: 'isOpen',
          i18nText: 'private_parking_activity_events_access_open',
          text: this.$i18n.t('private_parking_activity_events_access_open'),
          sortable: false
        },
        {
          value: 'type',
          i18nText: 'private_parking_activity_events_access_type',
          text: this.$i18n.t('private_parking_activity_events_access_type'),
          sortable: false
        },
        {
          value: 'description',
          i18nText: 'private_parking_activity_events_access_desc',
          text: this.$i18n.t('private_parking_activity_events_access_desc'),
          sortable: false
        }
      ]
    };
  },
  mounted() {},
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateTableLables);

    this.debounceSearch = _.debounce(this.queryChange, 500);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateTableLables);
  },
  methods: {
    onDatesSelected(dates) {
      if (typeof dates === 'undefined') {
        if (this.dates.length === 0) {
          return;
        }
      } else {
        this.dates = dates;
      }

      this.queryChange();
    },
    updateTableLables() {
      _.each(this.headers, itHeaders => {
        itHeaders.label = this.$i18n.t(itHeaders.i18nLabel);
      });
      // this.mapEventsRaw();
      this.queryChange();
    },
    loadData(params, sortInfo) {
      params.sort = 'desc';
      if (!_.isEmpty(sortInfo)) {
        if (sortInfo.column !== null && sortInfo.column.order === 'ascending') {
          params.sort = 'asc';
        }
      }

      doorService.list(params, this.doorListSuccessHandler, this.doorListErrorHandler);
    },
    queryChange() {
      this.isLoading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      let queryInfo = {
        pageSize: rowsPerPage,
        page: page,
        sortInfo: {
          column: {
            sortBy: sortBy,
            order: descending ? 'descending' : 'ascending'
          }
        }
      };

      let params = {
        parking: this.parkingId,
        length: queryInfo.pageSize,
        start: (queryInfo.page - 1) * queryInfo.pageSize,
        lang: store.state.langSelected.langWsp,
        fromDate: moment(this.dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        toDate: moment(this.dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        customerId: this.search
      };
      this.loadData(params, queryInfo.sortInfo);
    },
    doorListSuccessHandler(data) {
      this.eventsRaw = data.data;
      this.totalEvents = data.recordsTotal;
      this.mapEventsRaw();
    },
    doorListErrorHandler() {},
    mapEventsRaw() {
      this.events = [];
      this.$nextTick(() => {
        this.isLoading = false;
        this.events = _.map(this.eventsRaw, value => {
          return {
            dateCreated: moment(value.dateCreated).format('L HH:mm'),
            user: value.user,
            isOpen: value.isOpen.toString(),
            description: value.description,
            type: this.$i18n !== null ? this.$i18n.t(`door_event_${value.type}`) : `door_event_${value.type}`
          };
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}

.topDatesSelector {
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/DoorEventsTable.vue